(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      var bar = root.querySelector('[data-mr-sticky-atc]');
      var mainButton = root.querySelector('.mr-pdp__buy button[name="add"]');
      if (!bar || !mainButton) return;

      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          return;
        }
        // Only show once the button has been scrolled past (above the
        // viewport) — not while it simply hasn't been reached yet below.
        if (entry.boundingClientRect.bottom < 0) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }, { threshold: 0 });
      observer.observe(mainButton);

      var stickyButton = bar.querySelector('[data-mr-sticky-atc-button]');
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          if (mainButton.disabled) {
            var picker = root.querySelector('.mr-pdp__variant-picker');
            if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          mainButton.click();
        });
      }
    }

    document.querySelectorAll('.mr-pdp').forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

})();
